import React from 'react';
import { RichText } from 'prismic-reactjs';
import { useStaticQuery } from 'gatsby';
import { StyledBodyText } from './body-text.styled';
var BodyText = function BodyText(_ref) {
    var richText = _ref.richText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("907195184"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledBodyText, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.body_text_styles.text
    }, /*#__PURE__*/ React.createElement(RichText, {
        render: richText
    }));
};
export default BodyText;
